import DetailsToolbar from './container/index';

export default DetailsToolbar;



// WEBPACK FOOTER //
// ./src/components/page/DetailsToolbar/index.js